import { FEATURES, ACTIONS } from "./constants";
import { isAppAdmin } from "./app-admin";

const APP_ADMIN_LANDING = "/tutorial-management";

const LOADING_LANDING = "/main/dashboard";

const NO_ACCESS_LANDING = "/access-denied";

const LANDING_CANDIDATES = [
    {
        path: "/admin",
        feature: FEATURES.ADMIN_DASHBOARD,
        skipDuringTrial: true,
        companyLevel: true,
    },
    { path: "/main/dashboard", feature: FEATURES.DASHBOARD },
    { path: "/main/reservations", feature: FEATURES.RESERVATIONS },
    { path: "/main/guestinfo/all", feature: FEATURES.GUEST_MANAGEMENT },
    { path: "/main/guestinfo/arrival", feature: FEATURES.CHECK_IN },
    { path: "/main/guestinfo/departure", feature: FEATURES.CHECK_OUT },
    { path: "/main/guestinfo/draft", feature: FEATURES.DRAFT },
    { path: "/main/housekeeping-tasks", feature: FEATURES.HOUSEKEEPING_TASKS },
    { path: "/main/customer-support", feature: FEATURES.CUSTOMER_SUPPORT },
    { path: "/main/customer-charges/charges-postings", feature: FEATURES.CHARGE_POSTING },
    { path: "/main/customer-charges/paid-out", feature: FEATURES.PAID_OUT },
    { path: "/main/customer-charges/guest-disbursement", feature: FEATURES.GUEST_DISBURSEMENT },
    { path: "/main/channel-management/room-update", feature: FEATURES.CHANNEL_MANAGEMENT },
    { path: "/main/asset-management", feature: FEATURES.INVENTORY_ITEMS },
    { path: "/main/offline-arrival", feature: FEATURES.OFFLINE_ARRIVAL },
    { path: "/main/sales-report", feature: FEATURES.SALES_REPORT },
    { path: "/main/gst-report", feature: FEATURES.GST_REPORT },
    { path: "/main/foreigner-report", feature: FEATURES.FOREIGNER_REPORT },
    { path: "/main/occupancy-report", feature: FEATURES.OCCUPANCY_REPORT },
    { path: "/main/cancellation-report", feature: FEATURES.CANCELLATION_REPORT },
    { path: "/main/guest-report", feature: FEATURES.GUEST_REPORT },
    { path: "/main/collection-report", feature: FEATURES.COLLECTION_REPORT },
    { path: "/main/housekeeping-report", feature: FEATURES.HOUSEKEEPING_REPORT },
    { path: "/main/night-audit-process", feature: FEATURES.NIGHT_AUDIT },
    { path: "/main/night-audit-report", feature: FEATURES.NIGHT_AUDIT_REPORT },
    { path: "/main/night-audit-operational-report", feature: FEATURES.NIGHT_AUDIT_OPERATIONAL_REPORT },
    { path: "/main/facilitysettings", feature: FEATURES.HOTEL_SETTINGS },
    { path: "/main/notification", feature: FEATURES.NOTIFICATION_SETTINGS },
    { path: "/main/user-management", feature: FEATURES.USER_MANAGEMENT },
    { path: "/main/role-management", feature: FEATURES.ROLE_MANAGEMENT },
    { path: "/main/audit-management", feature: FEATURES.AUDIT_MANAGEMENT },
    { path: "/main/tutorial-view", feature: FEATURES.TUTORIAL },
];

export const isLandingRouteResolving = (
    permissions,
    roleCode,
    isOnline = true,
    permissionsError = null
) => isOnline && !isAppAdmin(roleCode) && !permissions && !permissionsError;

export const resolveHotelLandingRoute = (permissions, isTrial) => {
    if (!permissions) return LOADING_LANDING;

    for (const candidate of LANDING_CANDIDATES) {
        if (candidate.companyLevel) continue;
        if (candidate.skipDuringTrial && isTrial) continue;
        if (permissions[candidate.feature]?.includes(ACTIONS.VIEW)) {
            return candidate.path;
        }
    }

    return NO_ACCESS_LANDING;
};

export const resolveLandingRoute = (permissions, roleCode, isTrial, isOnline = true) => {
    if (!isOnline) return "/main/offline";

    if (isAppAdmin(roleCode)) return APP_ADMIN_LANDING;

    if (!permissions) return LOADING_LANDING;

    for (const candidate of LANDING_CANDIDATES) {
        if (candidate.skipDuringTrial && isTrial) continue;
        if (permissions[candidate.feature]?.includes(ACTIONS.VIEW)) {
            return candidate.path;
        }
    }

    return NO_ACCESS_LANDING;
};

export default resolveLandingRoute;
